import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8 max-w-2xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M15 19l-7-7 7-7"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Back to Votes ")
const _hoisted_5 = { class: "bg-white rounded-xl border border-primary-200 shadow-soft p-6 md:p-8" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<h1 class=\"text-display-sm font-heading font-bold text-primary-800 mb-2\"> Create a New Vote </h1><p class=\"text-primary-500 mb-6\"> Create a formal vote for the community. Once published, households can cast their ballots until the deadline. </p><div class=\"bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6\"><div class=\"flex gap-3\"><svg class=\"w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z\"></path></svg><div><p class=\"text-sm font-medium text-amber-800\">Important</p><p class=\"text-sm text-amber-700\"> To edit a vote in progress, contact a Neighborhood Admin. Some edits may invalidate existing ballots and require a restart. </p></div></div></div>", 3)

import CreateVote from "@/components/ballot/CreateVote.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/votes",
        class: "inline-flex items-center gap-2 text-primary-700 hover:text-primary-800 mb-6"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _hoisted_4
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(CreateVote)
      ])
    ])
  ]))
}
}

})